// extracted by mini-css-extract-plugin
module.exports = {"security":"b_b","iconSecurity":"b_c","label":"b_d","title":"b_f","description":"b_g","point":"b_h","icon":"b_j","name":"b_k","banner":"b_l"};